export type ThemeColorFields = 'basic' | 'all'

// eslint-disable-next-line unused-imports/no-unused-vars
export const themeColorGQLFields = (fields: ThemeColorFields) => `
  key
  weights {
    key
    value
  }
`
